module.exports = __webpack_public_path__ + "media/images/top/img_tab_chariloto_select-9cb586195c84c3504e2785a22e51d86e.png";